module.exports = __webpack_public_path__ + "img/能耗成本@3x.684d81f5.png";